<app-processing [visible]="!pageVars.isReady"></app-processing>

<div class="flex justify-content-between flex-wrap">
  <div class="flex align-items-center justify-content-center">
    <p-breadcrumb [model]="pageVars.breadcrumbItems">
      <ng-template let-item let-last="last" let-first="first" pTemplate="item">
        <ng-container *ngIf="!first">
          <a *ngIf="item.routerLink" [routerLink]="item.routerLink">{{ item.label }}</a>
          <div *ngIf="!item.routerLink" class="breadcrumb-current-item">{{ item.label }}</div>
        </ng-container>
      </ng-template>
    </p-breadcrumb>
  </div>
  <div class="flex align-items-center justify-content-center">
    <p-button pTooltip="Reset Table" tooltipPosition="top" icon="pi pi-refresh" [raised]="true" class="mr-2" (click)="resetPage(dt)"></p-button>
    <p-button
      pTooltip="Clear Filter/Sort"
      tooltipPosition="top"
      *ngIf="filtersActive"
      icon="pi pi-filter-slash"
      [raised]="true"
      (click)="clearFilters(dt)"></p-button>
  </div>
  <div class="flex align-items-center justify-content-center">
    <p-button
      label="Add Vendor Name & Permit"
      class="mr-2"
      [raised]="true"
      iconPos="right"
      (onClick)="addVendorName()"
      [disabled]="selectedInstances.length === 0"></p-button>
    <p-button
      label="Add Expected Vendor Delivery Date"
      class="mr-2"
      [raised]="true"
      iconPos="right"
      (onClick)="addVendorDeliveryDate()"
      [disabled]="selectedInstances.length === 0"></p-button>
    <p-button
      label="Add Vendor Delay Info"
      class="mr-2"
      [raised]="true"
      iconPos="right"
      (onClick)="addVendorDelayInfo()"
      [disabled]="selectedInstances.length === 0"></p-button>
    <p-button class="mr-2" label="Export" [raised]="true" iconPos="right" (onClick)="exportThisList()"></p-button>
  </div>
</div>
<p-table
  #dt
  [value]="instances"
  [columns]="cols"
  [reorderableColumns]="true"
  [resizableColumns]="true"
  columnResizeMode="expand"
  [paginator]="true"
  [first]="skip"
  [rows]="take"
  [totalRecords]="totalCount"
  [filterDelay]="300"
  [lazy]="true"
  stateStorage="local"
  stateKey="vendor-order-table"
  (onLazyLoad)="handleTableEvents($event)"
  [(selection)]="selectedInstances"
  dataKey="InstanceId"
  [scrollable]="true"
  [scrollHeight]="'60vh'">
  <ng-template #header let-columns>
    <tr>
      <th style="width: 3rem">
        <p-checkbox inputId="selectAll" [binary]="true" [ngModel]="selectAllToggle" (click)="toggleSelectAll(!selectAllToggle)"></p-checkbox>
      </th>
      <th
        *ngFor="let col of columns"
        pResizableColumn
        pReorderableColumn
        [pSortableColumn]="col.field"
        [ngStyle]="col.headerStyle || getColumnHeaderStyle(col.field)">
        {{ col.header }}
        <p-sortIcon [field]="col.field"></p-sortIcon>
        <p-columnFilter
          [type]="col.type"
          [field]="col.field"
          placeholder="Filter.."
          display="menu"
          class="ml-1"
          [matchModeOptions]="col.type === 'text' ? customMatchModeOptions : col.type === 'date' ? dateMatchModeOptions : col.type === 'numeric' ? numericMatchModeOptions : undefined">
        </p-columnFilter>
      </th>
    </tr>
  </ng-template>
  <ng-template #body let-instance let-columns="columns">
    <tr>
      <td>
        <p-checkbox [value]="instance.InstanceId" [(ngModel)]="selectedInstances" (onChange)="selectRowClick()"></p-checkbox>
      </td>
      <td *ngFor="let col of columns" [ngStyle]="col.style">
        <ng-container [ngSwitch]="col.template">
          <a *ngSwitchCase="'link'" [routerLink]="['/orders', instance.OrderId, 'vendor']">
            {{ instance[col.field] }}
          </a>
          <div *ngSwitchCase="'tooltip'" [pTooltip]="instance[col.field]" tooltipPosition="top" class="text-line-clamp-3">
            {{ instance[col.field] }}
          </div>
          <ng-container *ngSwitchDefault>
            {{ instance[col.field] }}
          </ng-container>
        </ng-container>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="cols.length + 1">No orders found.</td>
    </tr>
  </ng-template>
</p-table>

<p-dialog
  *ngIf="showAddVendorDeliveryDateModel"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="showAddVendorDeliveryDateModel"
  appendTo="body"
  styleClass="order-item-dialog"
  [style]="{ 'width': '35rem' }">
  <h4 style="font-weight: bold; margin-top: 0px">Add Expected Vendor Delivery Date</h4>
  <div class="grid">
    <div class="col mb-2 mt-2">
      <div class="flex align-content-center flex-wrap w-full">
        <p-floatlabel variant="on">
          <p-datepicker
            class="required"
            id="vendorDeliveryDate"
            [(ngModel)]="vendorDeliveryDate"
            [showIcon]="true"
            data-testId="vendorDeliveryDate"
            [iconDisplay]="'input'"
            inputId="icondisplay"
            appendTo="body"></p-datepicker>
          <label for="on_label">Date</label>
        </p-floatlabel>
      </div>
    </div>
  </div>
  <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
    <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="onCancelVendorDeliveryDate()" data-testid="newItemCancel" />
    <p-button label="Add" icon="fa fa-check" severity="success" size="small" [raised]="true" (click)="onSaveVendorDeliveryDate()" data-testid="newItemSave" />
  </div>
</p-dialog>

<p-dialog
  *ngIf="showAddVendorNameAndPermitModel"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="showAddVendorNameAndPermitModel"
  appendTo="body"
  styleClass="order-item-dialog"
  [style]="{ 'width': '35rem' }">
  <h4 style="font-weight: bold; margin-top: 0px">Add Vendor Name & Site Permit</h4>
  <div class="grid">
    <div class="col mt-2 mb-2">
      <label for="vendors">Vendor Name</label>
      <p-floatlabel style="width: 100%">
        <p-select
          [(ngModel)]="vendorId"
          [options]="vendors"
          inputId="vendors"
          data-testid="vendorName"
          optionLabel="name"
          optionValue="id"
          [filter]="true"
          filterPlaceholder="Search Vendor"
          appendTo="body"
          [style]="{ width: '100%', zIndex: '1100' }"
          [class]="'w-full required' + (isVendorSelected ? ' filled' : '')"></p-select>
      </p-floatlabel>
    </div>
  </div>
  <div class="grid">
    <div class="col mt-2 mb-2">
      <label for="permits">Site Permit</label>
      <p-floatlabel style="width: 100%">
        <p-select
          [(ngModel)]="vendorSitePermit"
          [options]="permits"
          inputId="permits"
          data-testid="insectPermit"
          optionLabel="name"
          optionValue="id"
          [filter]="true"
          filterPlaceholder="Search Permit"
          appendTo="body"
          [style]="{ width: '100%', zIndex: '1100' }"
          [class]="'w-full required' + (isPermitSelected ? ' filled' : '')"></p-select>
      </p-floatlabel>
    </div>
  </div>
  <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
    <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="onCancelVendorNameAndPermit()" data-testid="newItemCancel" />
    <p-button label="Add" icon="fa fa-check" severity="success" size="small" [raised]="true" (click)="onSaveVendorNameAndPermit()" data-testid="newItemSave" />
  </div>
</p-dialog>

<p-dialog
  *ngIf="showAddVendorDelayInfoModel"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="showAddVendorDelayInfoModel"
  appendTo="body"
  styleClass="order-item-dialog"
  [style]="{ 'width': '35rem' }">
  <h4 style="font-weight: bold; margin-top: 0px">Add Vendor Delay Information</h4>
  <div class="grid">
    <div class="col">
      <div class="flex">
        <label for="active" style="padding-right: 1rem">Vendor Delay Flag :</label>
        <p-toggleswitch [(ngModel)]="vendorDelayFlag" data-testid="active" />
      </div>
    </div>
  </div>
  <div class="grid mt-1">
    <div class="col-12">
      <p-floatlabel variant="on">
        <textarea pTextarea data-testid="note" [(ngModel)]="vendorDelayNote" rows="8" style="resize: none" class="w-full h-full"></textarea>
        <label for="on_label">Vendor Delay Note</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
    <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="onCancelVendorDelayInfo()" data-testid="newItemCancel" />
    <p-button label="Add" icon="fa fa-check" severity="success" size="small" [raised]="true" (click)="onSaveVendorDelayInfo()" data-testid="newItemSave" />
  </div>
</p-dialog>
